export const environment = {
  production: false,
  uat: false,
  staging: true,
  development: false,
  environment: 'staging',
  baseUrl: 'https://stg-clone-qldhealth-nq-api.tracwater.online',
  portalId: '69d4be891096f314fd6c27d6',
  portalTypeId: '689596b618f8a8985a2aeb91',
  predictionURL:'https://testing-predection.tracwater.online/api/v1',
};
